<template>
  <div class="error-page">
    <div class="error-img">
      <img src="../../assets/images/error-404.png" alt />
    </div>
    <div class="error-result">对不起，当前直播已结束...</div>
    <div class="error-btn">
      <Button type="primary" :to="{ name: 'Home' }">返回首页</Button>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
export default {
  mixins: [siteMixin],
  mounted() {
    this.setMetaData("直播已结束");
  },
};
</script>

<style lang="less" scoped>
.error-page {
  margin: 164px auto;
  .error-img {
    width: 255px;
    height: 295px;
    margin: 0 auto;
  }
  .error-result {
    margin-top: 3rem;
    font-size: 1.6rem;
    text-align: center;
    color: #666;
  }
  .error-btn {
    margin-top: 3rem;
    text-align: center;
  }
}
</style>